<template>
	<div>
		<Breadcrumbs main="Accessories" title="Add Accessories" />
		<div class="container-fluid">
			<div class="row">
			   <div class="col-sm-12">
				  <div class="card">
					 <div class="card-body">
						<form @submit.prevent="addAccessory" enctype="multipart/form-data" @hidden="clearForm()">
						   <div class="form theme-form">
								<div class="row">
									<div class="col-sm-6">
										<div class="mb-3">
											<label class="control-label">Title <span class="text-danger">*</span></label>
											<!-- <input class="form-control" type="text" placeholder=""> -->
											<input class="form-control" type="text" placeholder="" v-model="accessory.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }" minlength="3" maxlength="200"/>
											<div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-6">
										<div class="mb-3">
											<label class="control-label">Price <span class="text-danger">*</span></label>
											
											<input class="form-control" type="text" placeholder="" v-model="accessory.price" v-bind:class="{ 'is-invalid': Boolean(errors.price) }" minlength="3" maxlength="200" @keypress="decimalsOnly"/>
											<div v-for="(val, index) in errors.price" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-sm-6" v-if="users.length">
										<div class="mb-3">
											<label class="control-label">User <span class="text-danger">*</span></label>

											<select class="form-select" v-model="accessory.user_id" v-bind:class="{ 'is-invalid': Boolean(errors.user_id) }">
												<option :value="null" disabled>-- Select User --</option>
												<option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
											</select>

											
										</div>
									</div>
									<div class="col-sm-6">
										<div class="mb-3">
											<label class="control-label">Category <span class="text-danger">*</span></label>
											
											<select class="form-select" v-model="accessory.cat_id" v-bind:class="{ 'is-invalid': Boolean(errors.cat_id) }">
												<option :value="null" disabled>-- Select Category --</option>
												<option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.cat_name }}</option>
											</select>
											<div v-for="(val, index) in errors.cat_id" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-sm-12">
										<div class="mb-3">
											<label class="control-label">Description <span class="text-danger">*</span></label>
											<textarea class="form-control" type="textarea" placeholder="" rows="4" max-rows="6" v-model="accessory.description" v-bind:class="{ 'is-invalid': Boolean(errors.description) }"></textarea>
											<div v-for="(val, index) in errors.description" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
								</div>	

								<div class="row">
									<div class="col-sm-12">
										<div class="mb-3">
											<label class="control-label">Location <span class="text-danger">*</span></label>
											
											<GMapAutocomplete 
												@place_changed="setPlace" class="form-control" 
												placeholder="Search here to pick the required latitude and longitude..."
												:value="accessory.location">
											</GMapAutocomplete>

											<GMapMap  v-if="accessory.location"
												:center="center"
												:zoom="18"
												map-style-id="roadmap"
												:options="mapOptions"
												style="width: 100%; height: 30vmin"
												ref="mapRef"
												@click="handleMapClick">
													<GMapMarker 
														:position="marker.position"
														:clickable="true"
														:draggable="true"
														@drag="handleMarkerDrag"
														@click="panToMarker"
													/>
											</GMapMap > 

											<div v-for="(val, index) in errors.location" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>

										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-sm-6">
										<div class="mb-3">
											<label class="control-label">Latitude<span class="text-danger">*</span></label>
											
											<input v-model="marker.position.lat" class="form-control" type="text" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"/>
											<div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-6">
										<div class="mb-3">
											<label class="control-label">Longitude <span class="text-danger">*</span></label>
											
											<input v-model="marker.position.lng" type="text" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"/>
											<div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-sm-6">
										<div class="mb-3">
											<label class="control-label">Images <span class="text-danger">*</span></label>

											<div class="row" v-for="(input, index) in inputs" :key="index">    
												<div class="col-md-6 form-group">    

													<input ref="fileinput" type="file" @change="setFile($event, index)" accept="image/*" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
													<span>
														<i class="fa fa-minus-circle text-danger" @click="remove(index)" v-show="index || ( !index && inputs.length > 1)"></i>
														<i class="fa fa-plus-circle text-success" @click="add()" v-show="index == inputs.length-1"></i>
													</span>
												</div>
												<div class="col" md="6">
													<img class="image-preview" v-bind:src="input.preview_image">
												</div>
											</div>
											
										</div>
									</div>

									<div class="col-sm-6">
										<div class="mb-3">
											<label class="control-label">Video</label>
											<input class="form-control" type="file" placeholder="">
											<!-- <b-form-input v-model="user.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
											<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div> -->
										</div>
									</div>
								</div>
							  
								<div class="col-sm-6">
									<!-- <a class="btn btn-primary me-3" type="submit">Add</a> -->
									<button class="btn btn-primary me-3" type="submit">Add</button>
									<a class="btn btn-light" >Reset</a>
									<!-- <button type="submit" class="mr-3" variant="primary">Add</button>
									<button class="" variant="light">Reset</button> -->
								</div>
							  <projectForm />
						   </div>
						</form>
					 </div>
				  </div>
			   </div>
			</div>
		</div>
 
   	</div>
</template>


<script>
import Multiselect from 'vue-multiselect'

	export default {
		name: "AddAccessory",
		components: {
			Multiselect
		},

		data() {
			
			return {
				accessory: {
					title: '',					
					cat_id: null,
					user_id: '',
					description: '',
					price: null,
					location: '',
					latitude: null,
					longitude: null,
					video: '',
					
				},

				marker: 
					{ position: 
						{ 
							lat: null, 
							lng: null 
						} 
					},
				center: { 
					lat: null, 
					lng: null 
				},

				current_place: null,

				mapOptions: {
					disableDefaultUI: true,
				},

				users: [
					
				],

				items: [

				],

				user: {
					// id: '',
					// name: '',
					// phone_number: '',
					// image: '',
				},

				categories: {},				
				inputs: [
					{value: null, preview_image: null}
				],

				// options: {
				// 	placeholder: 'User',
				// 	minInputLength: 1,
				// },

				value: null,

				options: [
					{ name: 'Vue.js', language: 'JavaScript' },
					{ name: 'Rails', language: 'Ruby' },
					{ name: 'Sinatra', language: 'Ruby' },
					{ name: 'Laravel', language: 'PHP', $isDisabled: true },
					{ name: 'Phoenix', language: 'Elixir' }
				],

				// image: "",
				// preview_image: "",

				inputs: [
					{value: null, preview_image: null}
				],
				images: [],

				images: [],
				keyword: '',
				visible: false,
				token: "",
				errors: {},

				// listFiltered: [],
			};
		},

		created() {
			this.fetchCategories();
			
			// this.listFiltered = this.items;

		},

		mounted() {
			this.fetchUsers();
		},

		methods: {

			add() {
				this.inputs.push({ value: null });
			},

			remove(index) {
				this.inputs.splice(index, 1);
				this.images.splice(index, 1);
			}, 

			setFile(e, index) {
				this.images.push(e.target.files[0]);
				this.inputs[index].image = e.target.files[0];
				this.inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
			},

			// setFile(e) {
			// 	this.image = e.target.files[0];
			// 	this.preview_image = URL.createObjectURL(e.target.files[0]);
			// },


			handleMarkerDrag(e) {
      			this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    		},

    		panToMarker() {
				this.$refs.mapRef.panTo(this.marker.position);
    		},

    		handleMapClick(e) {
				this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
				console.log(e);
    		},

			// panToMarker() {
			// 	this.$refs.mapRef.panTo(this.marker.position);
			// 	this.$refs.mapRef.setZoom(18);
			// },

		 	setPlace(place) {
		    	this.current_place = place;
		    	if(this.current_place) {
		    		const marker = {
			    		lat: this.current_place.geometry.location.lat(),
			    		lng: this.current_place.geometry.location.lng(),
			    	};
			    	this.center = marker;
			    	this.marker.position = marker;
			    	this.accessory.location = place.formatted_address;
					this.accessory.latitude = marker.lat;
	    			this.accessory.longitude = marker.lng;
		    	}
		   	},

			decimalsOnly(event) {
				let keyCode = event.keyCode;
				if (keyCode >= 48 || keyCode <= 57 || keyCode == 46 ) {
					return;
				} else {
					event.preventDefault();
				}
		    },
		    alphaSpacesOnly(event) {
		    	let keyCode = event.keyCode;
			    if ((keyCode >= 65 && keyCode <= 90) || 
			    	(keyCode >= 97 && keyCode <= 122) ||			    	
			    	(keyCode == 32)) {
			        return;
			    } else {
			    	event.preventDefault();
			    }
		    },
		   
			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			fetchCategories() {
				let url = "/api/admin/accessories/category";			
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.categories = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			fetchUsers() {
				let url = "/api/admin/users?limit=0&keyword=" + this.keyword;
				this.getToken();
				this.$axios
					.get(url, {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						var responseData = res.data.data;
						this.users = responseData.data;
						this.items = [];

						for(var i = 0; i < responseData.data.length; i++) {
							this.items.push(responseData.data[i].name + '|' + responseData.data[i].phone_number )
						}
						console.log(this.users);
						console.log(this.listFiltered);
						this.visible = true;
						this.accessory.user_id = null;
					})
					.catch((err) => console.log(err));
			},
			
			nameWithLang ({ name, phone_number }) {
				return `${name} — [${phone_number}]`
			},
			
			setUser() {
				this.keyword = event.target.options[event.target.options.selectedIndex].label;
				this.visible = false;
			},

			setVideo(event) {
				this.accessory.video = event.target.files[0];
			},

			// selectItem(item) {
			// 	console.log(item);
			// },
			// onInput(event) {
			// 	this.listFiltered = event.items;
			// },
			// onBlur(event) {
			// 	this.listFiltered = event.items;
			// },

			addAccessory() {

				this.getToken();
				let formData = new FormData();
				formData.append("title", this.accessory.title);
				formData.append("price", this.accessory.price);
				formData.append("cat_id", this.accessory.cat_id);
				formData.append("user_id", this.accessory.user_id);				
				formData.append("description", this.accessory.description);
				formData.append("location", this.accessory.location);
				formData.append("latitude", this.marker.position.lat);
				formData.append("longitude", this.marker.position.lng);
				// formData.append("latitude", this.marker.position.lat);
				// formData.append("longitude", this.marker.position.lng);
				formData.append("video", this.accessory.video);		


				for(var j = 0; j < this.images.length; j++) {
				  	let file = this.images[j];
				   formData.append('images[' + j + ']', file);
				}
				// formData.append("images", this.image);

				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};

				let url;
				url = "/api/admin/accessories/add";

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.$router.push({ name: "existingaccessories" });
						this.clearForm();
					})
					.catch((error) => {
						this.errors = {};
						if (error.response) {
							if (error.response.data.message) {
								console.log(error.response.data);
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
								console.log(this.errors);
							} else {
                            this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			clearForm() {
				this.fetchCategories();				

				this.accessory.title = "";
				this.accessory.description = "";				
				this.accessory.cat_id = null;
				this.accessory.user_id = null;
				this.accessory.price = null;
				this.accessory.location = '';
				this.marker.position.lat = null;
				this.marker.position.lng = null;
				this.accessory.video = null,
				this.inputs = [{value: null, preview_image: null}];
	         	this.images = [];
				this.errors = {};
				this.keyword = '';
				
			},
		},
	};
</script>
